import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=3de81a03&scoped=true&"
import script from "./Results.js?vue&type=script&lang=js&"
export * from "./Results.js?vue&type=script&lang=js&"
import style0 from "./Results.scss?vue&type=style&index=0&id=3de81a03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de81a03",
  null
  
)

export default component.exports